import { mySubjectsActionTypes } from '.';

export const init = (view: StaticView) => ({
  type: mySubjectsActionTypes.INIT,
  payload: { view },
} as const);
export const getFiltersList = (view: StaticView) => ({
  type: mySubjectsActionTypes.FILTERS_GET_CONFIG_START,
  payload: { view },
} as const);
export const getData = (view: StaticView) => ({
  type: mySubjectsActionTypes.GET_DATA_START,
  payload: { view },
} as const);
export const syncDataWithCache = (view: StaticView) => ({
  type: mySubjectsActionTypes.SYNC_DATA_WITH_CACHE_START,
  payload: { view },
} as const);
export const getColumnsConfig = (view: StaticView) => ({
  type: mySubjectsActionTypes.COLUMNS_GET_CONFIG_START,
  payload: { view },
} as const);
export const saveColumnsUserSetup = (view: StaticView, selectedColumns: SelectedColumns) => ({
  type: mySubjectsActionTypes.COLUMNS_SAVE_USER_SETUP_START,
  payload: { view, selectedColumns },
} as const);
export const refreshFilterValues = (view: StaticView) => ({
  type: mySubjectsActionTypes.FILTERS_REFRESH_VALUES_START,
  payload: { view },
} as const);
export const getRecordDetails = (view: StaticView, id: string | number) => ({
  type: mySubjectsActionTypes.RECORD_GET_DETAILS_START,
  payload: { view, id },
} as const);
export const refreshData = (view: StaticView) => ({
  type: mySubjectsActionTypes.REFRESH_DATA_START,
  payload: { view },
} as const);
